module.exports = __webpack_public_path__ + "img/profile_stvldf_2.bf3fea6c.png";